import type { SVGProps } from 'react';

const SvgArrowRightUpLt = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path d='M17.957 6L5.95703 18M17.957 6V15M17.957 6H8.95703' stroke='currentColor' strokeLinecap='round' />
  </svg>
);
export default SvgArrowRightUpLt;
